import { render, staticRenderFns } from "./UpgradeCard.vue?vue&type=template&id=ef3a118c&scoped=true"
import script from "./UpgradeCard.vue?vue&type=script&lang=js"
export * from "./UpgradeCard.vue?vue&type=script&lang=js"
import style0 from "./UpgradeCard.vue?vue&type=style&index=0&id=ef3a118c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3a118c",
  null
  
)

export default component.exports